import React from 'react'
import './company-logo.scss'

const CompanyLogo = () => {



  const collaborations = [
    '/images/collaborations/logo1.svg',
    '/images/collaborations/logo2.svg',
    '/images/collaborations/logo3.svg',
    '/images/collaborations/logo4.svg',
    '/images/collaborations/logo6.svg',
    '/images/collaborations/logo5.svg',
    '/images/collaborations/logo7.svg',
  ];


  return (
    <section className="company-logo-section">
      <div className="cotainer">
        <div className="logos-wrap">
          {collaborations.map((src, index) => (
            <div key={index} className="logo-item">
              <img src={src} alt={`logo-${index}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CompanyLogo